import { useContext } from 'react';

import { LanguageContext } from '@/shared/contexts';

export const useLang = () => {
  const { changeLang, lang } = useContext(LanguageContext);

  return {
    changeLang,
    lang,
  };
};
